module.exports = __webpack_public_path__ + "static/media/Sensor.4a0d16c1.svg";